var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"so-blue so-center",staticStyle:{"height":"100%"},on:{"click":_vm.containerClicked}},[_c('div',{staticClass:"more-yao-button",attrs:{"id":"more-yao-button"},on:{"click":_vm.moreClicked}})])}
var staticRenderFns = []

export { render, staticRenderFns }